export namespace JatakTabAction {
  export class SetJatakTab {
    static readonly type = "[SetJatakTabState] Set Tab Data"

    constructor(public tab : any) {
    }
  }
}
